import patternValidators from 'helpers/validators/pattern-validators';

import BrandingTabSplitLayout from 'components/BrandingTabSplitLayout/BrandingTabSplitLayout';
import { Input } from 'components/FormComponents/Input/Input';
import { InputGroup } from 'components/FormComponents/InputGroup/InputGroup';

export const Clicktrought = ({
  register,
  watch,
  readOnly,
  backgroundColor,
  brand,
  control,
  errors,
}) => {
  const candidateUrl = watch('click_through_candidate');
  const refereeUrl = watch('click_through_referee');

  return (
    <BrandingTabSplitLayout key={brand?.id} shellClassName={backgroundColor}>
      <div className="flex flex-col gap-8">
        <section className="rounded-3xl border border-neutral-4 bg-white p-6 shadow-sm">
          <InputGroup
            title="Candidate redirect URL"
            description="When set, candidates are redirected to this URL after completing their checks."
            noMargin>
            <Input
              name="click_through_candidate"
              register={register}
              disabled={readOnly}
              validators={patternValidators.website}
              error={errors.click_through_candidate?.message}
              placeholder="https://www.checkmate.tech/"
            />
            {candidateUrl && !errors?.click_through_candidate?.message && (
              <a
                href={candidateUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-xl font-semibold text-primary-4">
                Preview URL
              </a>
            )}
          </InputGroup>
        </section>
        <section className="rounded-3xl border border-neutral-4 bg-white p-6 shadow-sm">
          <InputGroup
            title="Referee redirect URL"
            description="When set, referees are redirected to this URL after completing their reference."
            noMargin>
            <Input
              name="click_through_referee"
              register={register}
              validators={patternValidators.website}
              error={errors.click_through_referee?.message}
              disabled={readOnly}
              placeholder="https://www.checkmate.tech/"
            />
            {refereeUrl && !errors?.click_through_referee?.message && (
              <a
                href={refereeUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-xl font-semibold text-primary-4">
                Preview URL
              </a>
            )}
          </InputGroup>
        </section>
      </div>
    </BrandingTabSplitLayout>
  );
};
